module.exports = __webpack_public_path__ + "img/20190628160828646.297cd44c.png";